import { Dropdown, ModalWrapper, TextInput } from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { updateDonations } from "../../actions/donations";
import { getBeneficiariesData, getTeamsData } from "../../selectors";

const defaultState = {
  first_name: "",
  last_name: "",
  email_address: "",
  donation_data: "",
  donation_amount: "",
  selected_team: "",
  selected_beneficiary: "",
  comment: "",
  account_number: "",
  input_address: "",
  input_city: "",
  input_state: "",
  input_zip: "",
};

const UpdateDonationsModal = ({ donation }) => {
  const dispatch = useDispatch();
  const [form, setForm] = useState(defaultState);

  const beneficiariesData = useSelector(getBeneficiariesData);
  const beneficiariesArray = beneficiariesData.map((item) => item["beneficiary_name"]); // prettier-ignore

  const teamsData = useSelector(getTeamsData);
  const teamsArray = teamsData.map((item) => item["team_name"]);

  const handleFormSubmit = () => {
    const donationObject = {
      ...form,
      id: donation.id,
    };
    dispatch(updateDonations(donationObject));
    return true;
  };

  useEffect(() => {
    const date = new Date().toISOString();

    setForm({
      ...defaultState,
      first_name: donation.cells[0].value,
      last_name: donation.cells[1].value,
      email_address: donation.cells[2].value,
      donation_data: date,
      donation_amount: donation.cells[4].value,
      selected_team: donation.cells[5].value,
      selected_beneficiary: donation.cells[6].value,
      comment: donation.cells[7].value,
      account_number: donation.cells[8].value,
      input_address: donation.cells[9].value,
      input_city: donation.cells[10].value,
      input_state: donation.cells[11].value,
      input_zip: donation.cells[12].value,
    });
  }, [donation]);

  return (
    <div style={{ padding: "1rem" }}>
      <ModalWrapper
        aria-label="Update Donation Modal"
        buttonTriggerText="Update Donation"
        disabled={false}
        handleSubmit={handleFormSubmit}
        hasScrollingContent={false}
        id="update-donations-modal"
        modalHeading="Update Donation"
        primaryButtonText="Update"
        renderTriggerButtonIcon={undefined}
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        shouldCloseAfterSubmit={true}
        triggerButtonKind="ghost"
      >
        <TextInput
          id="firstname-updatedonation"
          invalid={false}
          invalidText="A valid value is required"
          labelText="First Name:"
          light={true}
          type="text"
          value={form.first_name}
          onChange={(e) => setForm({ ...form, first_name: e.target.value })}
        />
        <TextInput
          id="lastname-updatedonation"
          invalid={false}
          invalidText="A valid value is required"
          labelText="Last Name:"
          light={true}
          type="text"
          value={form.last_name}
          onChange={(e) => setForm({ ...form, last_name: e.target.value })}
        />
        <TextInput
          id="emailaddress-updatedonation"
          invalid={false}
          invalidText="A valid value is required"
          labelText="Email Address:"
          light={true}
          type="text"
          value={form.email_address}
          onChange={(e) => setForm({ ...form, email_address: e.target.value })}
        />
        <TextInput
          id="donationamount-updatedonation"
          invalid={false}
          invalidText="A valid value is required"
          labelText="Donation Amount:"
          light={true}
          type="number"
          value={form.donation_amount}
          onChange={(e) =>
            setForm({ ...form, donation_amount: e.target.value })
          }
        />
        <Dropdown
          style={{ paddingBottom: "0.75rem" }}
          id="beneficiary-updatedonation"
          titleText="Beneficiary:"
          label="Select Beneficiary:"
          items={beneficiariesArray}
          onChange={(e) =>
            setForm({ ...form, selected_beneficiary: e.selectedItem })
          }
          selectedItem={form.selected_beneficiary}
        />
        <Dropdown
          style={{ paddingBottom: "0.75rem" }}
          id="team-updatedonation"
          titleText="Team:"
          label="Select Team:"
          items={teamsArray}
          onChange={(e) => setForm({ ...form, selected_team: e.selectedItem })}
          selectedItem={form.selected_team}
        />
        <TextInput
          id="comment-updatedonation"
          invalid={false}
          invalidText="A valid value is required"
          labelText="Comment:"
          light={true}
          type="text"
          value={form.comment}
          onChange={(e) => setForm({ ...form, comment: e.target.value })}
        />
        <TextInput
          id="accountnumber-updatedonation"
          invalid={false}
          invalidText="A valid value is required"
          labelText="Account Number:"
          light={true}
          type="text"
          value={form.account_number}
          onChange={(e) => setForm({ ...form, account_number: e.target.value })}
        />
        <TextInput
          id="inputaddress-updatedonation"
          invalid={false}
          invalidText="A valid value is required"
          labelText="Address:"
          light={true}
          type="text"
          value={form.input_address}
          onChange={(e) => setForm({ ...form, input_address: e.target.value })}
        />
        <TextInput
          id="inputcity-updatedonation"
          invalid={false}
          invalidText="A valid value is required"
          labelText="City:"
          light={true}
          type="text"
          value={form.input_city}
          onChange={(e) => setForm({ ...form, input_city: e.target.value })}
        />
        <TextInput
          id="inputstate-updatedonation"
          invalid={false}
          invalidText="A valid value is required"
          labelText="State:"
          light={true}
          type="text"
          value={form.input_state}
          onChange={(e) => setForm({ ...form, input_state: e.target.value })}
        />
        <TextInput
          id="inputzip-updatedonation"
          invalid={false}
          invalidText="A valid value is required"
          labelText="Zip:"
          light={true}
          type="text"
          value={form.input_zip}
          onChange={(e) => setForm({ ...form, input_zip: e.target.value })}
        />
      </ModalWrapper>
    </div>
  );
};

UpdateDonationsModal.propTypes = {
  donation: PropTypes.object,
};

export default UpdateDonationsModal;
